<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Services
	import { format } from 'svelte-i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { rebootDevice } from '../../../../helpers/device_settings_helpers';
	import { capFirstChar } from '../../../../helpers/utilities';
	//Design system components
	import { Button, Select, Text, toast } from '@Shelly/shelly-design-system';
	//Components
	import ModalPrompt from '../../../../components/ModalPrompt.svelte';

	export let device;

	const id = real_id(device.id);
	$: settingsStore = getDeviceSettings(id);
	let settings = readDeviceSettings(id);
	$: settings = $settingsStore ?? settings;

	const wifiOptions = [true, false];
	const wifiOptionsI18n = [
		$format('option_wifi_led_enable', {
			default: 'On when WiFi is On (default)',
		}),
		$format('option_always_off', { default: 'Always off' }),
	];
	const powerOptions = ['match_output', 'inverted_output', 'on', 'off'];
	const powerOptionsI18n = [
		$format('option_power_led_match', {
			default: 'On when dimmer is on (default)',
		}),
		$format('option_power_led_inverted', { default: 'Off when dimmer is on' }),
		$format('option_always_on', { default: 'Always on' }),
		$format('option_always_off', { default: 'Always off' }),
	];

	// todo -> check this one
	console.log(settings?.wd_ui?.power_led);

	let wifiValue = wifiOptionsI18n[wifiOptions.indexOf(settings?.wd_ui?.sys_led_enable)];
	let _wifiVal = wifiOptions[wifiOptionsI18n.indexOf(wifiValue)];
	let cacheWifiValue = _wifiVal;
	let powerValue = powerOptionsI18n[powerOptions.indexOf(settings?.wd_ui?.power_led)];
	let _powerVal = powerOptions[powerOptionsI18n.indexOf(powerValue)];
	let cachePowerValue = _powerVal;
	let loading = false;
	let showModal = false;
	const props = {
		title: capFirstChar($format('sub_settings_title_device_reboot')),
		text: $format('reboot_description'),
		button_1: $format('button_reboot'),
		button_2: $format('button_cancel'),
		callback: () => rebootDevice(device),
	};

	const changeSysLed = async (e) => {
		_wifiVal = wifiOptions[wifiOptionsI18n.indexOf(e.detail)];
	};

	const changePowerLed = async (e) => {
		_powerVal = powerOptions[powerOptionsI18n.indexOf(e.detail)];
	};

	const sentRequests = async () => {
		let saveSysLed;
		let savePowerLed;
		if (cachePowerValue !== _powerVal) {
			loading = true;
			const params = {
				config: {
					power_led: _powerVal,
				},
			};

			savePowerLed = await gen2Request(device, 'Wd_Ui.SetConfig', params);
		}
		if (cacheWifiValue !== _wifiVal) {
			loading = true;
			const params = {
				config: {
					sys_led_enable: _wifiVal,
				},
			};

			saveSysLed = await gen2Request(device, 'Wd_Ui.SetConfig', params);
		}
		Promise.all([savePowerLed, saveSysLed]).then((res) => {
			if (typeof res[0] !== 'undefined') {
				if (res[0].isok) {
					settings.wd_ui.wifi_led_enable = _wifiVal;
					devices_settings.update_devices_settings(id, settings);
					toast.open({
						type: 'success',
						title: $format('setting_scc_saved_toast'),
					});
					cacheWifiValue = _wifiVal;
				} else {
					_wifiVal = cacheWifiValue;
					toast.open({ type: 'danger', title: $format('error_global') });
				}
				if (res[0]?.data?.restart_required) {
					showModal = true;
				}
			}
			if (typeof res[1] !== 'undefined') {
				if (res[1].isok) {
					settings.wd_ui.power_led_mode = _powerVal;
					devices_settings.update_devices_settings(id, settings);
					toast.open({
						type: 'success',
						title: $format('setting_scc_saved_toast'),
					});
					cachePowerValue = _powerVal;
				} else {
					_powerVal = cachePowerValue;
					toast.open({ type: 'danger', title: $format('error_global') });
				}
				if (res[1]?.data?.restart_required) {
					showModal = true;
				}
			}
			loading = false;
		});
	};
	//Leaving eventualy modal prompt because on some versions returns reboot required true
</script>

<Text styleType="body-small" class="mb-s">
	{$format('wifi_led_desc') ||
		'Blue LED on the device (behind the power button), that is used to indicate if the WiFi is connected.'}
</Text>
<Select
	class="mb-s"
	value={wifiValue}
	options={wifiOptionsI18n}
	icon={null}
	on:change={changeSysLed}
	id="select-e2mxanx"
	aria-label={$format('wifi_led_desc', { default: 'WiFi LED' })}
/>
<Text styleType="body-small" class="mb-s">
	{$format('power_led_desc') ||
		'White LED (behind the power button) that is On when the dimmer is turned on. You can change that behaviour here, by inverting it (Off when dimmer is on) or simply to set it to always on/off.'}
</Text>
<Select
	class="mb-s"
	value={powerValue}
	options={powerOptionsI18n}
	icon={null}
	on:change={changePowerLed}
	id="select-vecdri8"
	aria-label={$format('power_led_desc', { default: 'Power LED' })}
/>
<Button {loading} class="mt-s" size="m" width="full" on:click={sentRequests}
	>{$format('button_save')}</Button
>
{#if showModal}
	<ModalPrompt bind:showModal {props} />
{/if}
